import { render, staticRenderFns } from "./CheckoutList.vue?vue&type=template&id=08e337a1"
import script from "./CheckoutList.vue?vue&type=script&lang=js"
export * from "./CheckoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports